import { getBlockValue } from '~/renderers/getBlockValue';
import { getContentBlock } from '~/renderers/getContentBlock';

export function renderBlockValue(page, key) {
  return getBlockValue(getContentBlock(page, key), key);
}
